import { useState } from 'react';
import { Badge, Box, Link } from '@chakra-ui/react';
import { faPaperclip } from '@fortawesome/pro-regular-svg-icons';
import { CustomHeading, Icon } from 'shared-components';
import { BorderedRow } from '../atoms/bordered-row';
import { DocumentViewer } from '../organisms/DocumentViewer';
import { useTranslation } from "react-i18next";

type FileListItem = { name: string; urls: string[] };

export const FileList = ({ files, headerCountOverride }: { files: FileListItem[]; headerCountOverride?: number }) => {
    const { t } = useTranslation('common');
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewUrls, setPreviewUrls] = useState<string[]>();

  if (files.length === 0) {
    return null;
  }

  const headerCount = headerCountOverride ?? files.length;

  return (
    <>
      <CustomHeading level="h2" mb={2} fontSize="md">
        {t('common:documents')}
                      <Badge size="sm" borderRadius="full" gap={1} px={2} colorScheme="blue" ml={2}>
          <Icon colorScheme="blue" icon={faPaperclip} size="sm" />
          {headerCount}
        </Badge>
      </CustomHeading>
      <Box>
        {files.map(file => (
          <BorderedRow key={file.name} flexDirection={'row'} alignItems={'start'} gap={2} lineHeight={5} px={6}>
            <Icon icon={faPaperclip} height={5} />

            <Link
              onClick={() => {
                setPreviewUrls(file.urls);
                setIsPreviewOpen(true);
              }}
            >
              {file.name}
            </Link>

            {file.urls && file.urls.length >= 1 && (
              <Badge variant={'pill'} size={'md'} minWidth={5}>
                {file.urls.length}
              </Badge>
            )}
          </BorderedRow>
        ))}

        {isPreviewOpen && <DocumentViewer documents={previewUrls} onClose={() => setIsPreviewOpen(false)} />}
      </Box>
    </>
  );
};
